module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel wrapper column-flex"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "list-group flex-fill overflow-auto alt"
  }, [_vm._m(1), _vm._v(" "), _vm._l((10), function(i) {
    return _c('li', {
      staticClass: "list-group-item no-padder-horizontal"
    }, [_vm._m(2, true)])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-fixed"
  }, [_c('label', {
    staticClass: "i-switch bg-warning pull-right"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "aria-invalid": "false"
    }
  }), _vm._v(" "), _c('i')]), _vm._v(" "), _c('h4', {
    staticClass: "font-thin m-t-none m-b text-muted"
  }, [_vm._v("Análise de Cadastro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-group-item no-padder-horizontal"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "pull-right text-warning m-t-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" aguardando análise\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("João Pedro Amorim")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("atualizado 2 minutos atrás")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "pull-right text-warning m-t-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" aguardando análise\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Pedro Thiago Pereira")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("atualizado 2 horas atrás")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eca0dd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/dashboard/components/AnaliseCadastro.vue
// module id = 1942
// module chunks = 18